module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMAf0C/R5mo7wAAAHFJREFUGNOFkNENgCAMRAssIIYFjAyghgEsdv+ZpKcCiTH2o+X1QtorIVzWPOJtE5dsGBAXrWGgq8W3gBY/gtuoAIRZhBSiCmFNAEsoAZk+YfLeVwgi8vOnwtFD8t1Q09YB5rpob+FlrtlGtINo3XGqE40HESPE33LpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h2-7.png
// module id = pQvM
// module chunks = 1